<template>
  <div class="robot-reply-container">
    <!-- <div
      v-if="msgLoading"
      class="hx-flex-c-c container-item"
      style="padding: 0.5em 0"
    >
      <van-loading />
    </div> -->

    <div class="hx-flex-c-c" v-if="showASRContainer">
      <div
        class="hx-flex-c-c container-item"
        style="display: inline-block; padding: 10px 10px; font-size: 0"
      >
        <div style=" display: flex;flex-direction: row;justify-content: start;align-items: center;">

          <RecordCool v-if="textStatus.text === '松开完成，上滑取消'"  />
          <!--语音识别结果的正方形绿色特效 -->
          <img
            v-else-if="textStatus.text === '识别到结果'"
            class="loading-gif"
            style="height: 38px"
            :src="require('/src/assets/icon/sy.gif')"/>
            alt=""
            srcset=""
          />
          <div v-if="ASRText" style="font-size: 14px; margin: 0 0.5em">
             {{ASRText }}
          </div>
        </div>
      </div>
    </div>

    <!-- 加载特效gif -->
    <div  class="hx-flex" v-if="msgLoading">
      <div
        class="hx-flex container-item-new"
        style="display: inline-block; padding: 0; font-size: 0;width: fit-content;">
<!--       hx-flex-c-c hx-flex-c-c  jz.gif-->
<!--        <img
          class="loading-gif"
          :src="require('/src/assets/icon/waiting.gif')"
          alt=""
          srcset=""
        />-->
        <div class="google-loader">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <!--用户询问的问题-->
    <div class="container-item container-item-question" v-if="questionContent">
      <div class="question_div" v-if="false"></div>
      <div class="content" style="margin-top: 0">{{ questionContent}}</div>
    </div>

    <!-- 回答的问题 -->
    <div class="container-item container-item-answer" v-if="content">
      <div class="reply_div" v-if="false"></div>
      <div class="content" style="margin-top: 0">{{ content}}</div>
    </div>
    <!-- <div v-if="content && !msgLoading" class="content container-item">
      {{ content }}
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import RecordCool from '@/views/home/components/RecordCool.vue'
export default {
  name: "RobotReplyContainer",
  components:{
    RecordCool
  },
  data() {
    return {
      msgLoading: false,
      showASRContainer: false,
      ASRText: '',
      content: '',
      questionContent: '', // 下方的提问文本
      textStatus: {}
    };
  },
  computed: {
    nickname() {
      return this.vuex_app_user_info?.nickname || "-";
    },
    biography() {
      return this.vuex_app_user_info?.biography || "-";
    },
    title() {
      return  this.vuex_app_user_info?.title || "";
    },
    company_name() {
      return  this.vuex_app_user_info?.company_name || "";
    },
  },
  created() {
    Vue.prototype.$_changeMsg = this.changeMsg;
    this.changeMsg({ content: this.vuex_app_user_info?.biography });

    // Vue.prototype.$_changeQuestionMsg = this.changeQuestionMsg

  },
  mounted() {
  },
  beforeDestroy() {},
  methods: {
    changeASRShow(data = false) {
      this.showASRContainer = data;
    },
    changeASRText(data = '', showContent, textStatus) {
      this.textStatus = textStatus
      this.ASRText = data;
      if (showContent){
        this.questionContent = data;
      }
    },

    changeLoading(data) {
      this.msgLoading = data;
    },
    changeMsg(data = {}) {
      console.log('enter changeMsg changeQuestionMsg')
      const {
        // title = this.vuex_app_user_info?.nickname || "-",
        content = '',
      } = data;
      // this.title = title;
      console.log('change msg reply ', content)
      this.content = content;
    },
    changeQuestionMsg(data = {}) {
      console.log('enter changeQuestionMsg')
      const {
        // title = this.vuex_app_user_info?.nickname || "-",
        content = '',
      } = data;
      // this.title = title;
      // console.log('change msg question', content)
      if (content !== ''){
        this.questionContent = content
       /*  let chatHistory = this.$store.state.chatHistory
        let historyObject = {
          type: 'question',
          text: content
        }
        chatHistory.push(historyObject)
        this.$vuex('chatHistory', chatHistory) */
        let fullASK = []
        fullASK.push(content)
        fullASK.push('')
        this.$store.commit('addHistory', fullASK)
        // console.log('history changeQuestionMsg', chatHistory)
      }

    },
  },

};
</script>

<style lang="less" scoped>
.reply_div{
  position: absolute;
  top: 2px;
  left: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1edf41;

}
.question_div{
  position: absolute;
  top: 2px;
  right: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #32c5ff;
}
.robot-reply-container {
  color: #fff;
  width: 50%; // 不给小一点会撑开。。。可能有优先级吧
  flex: 1;
}
.container-item {
  position: relative;
  float: left;
  width: 100%;
  margin-top: 6px;
  padding: 4px 0 4px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}
.container-item-question{
  background: rgba(0, 138, 25, 0.3);
  // background: linear-gradient(to top, rgba(0, 138, 25, 0.3), rgba(0, 0, 25, 0.3)); /* 设置线性渐变背景，从白色到透明 */
  padding: 4px 8px 4px 4px;
  text-align: right;
  float: right;

  backdrop-filter: blur(10px); /* 使用模糊效果 */
}
.container-item-answer{
  backdrop-filter: blur(10px);
}
.icon_love{
  border-radius: 8px;
  background: rgba(77, 68, 66, 0.5);
  padding: 5px;
}
.custom_care{
  width: 70px;
  height: 24px;
  // margin-right: 10px;
  font-size: 12px;
  border-radius: 6px;

  font-weight: 400;
  color: #FFFFFF;
  line-height: 17px;
  font-style: normal;
}
.custom_care .van-icon {
  font-size: 12px !important;
}

.title {
  max-width: 120px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  // 超出内容省略号
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.show-box-right{
  float: right;
  // width: 150px;
  display: flex;
  justify-content: flex-end;
}
.content {
  float: left;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  max-height: 30vh;
  margin-top: 8px;
  width: 100%;
}
.content {
  overflow-y: auto;
}
.content::-webkit-scrollbar {
  width: 4px;
}
.content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
}
.content::-webkit-scrollbar-track {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
}

.loading-gif {
  height: 60px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background: transparent;

  margin: 0;
  padding: 0;
  // margin-bottom: -1px;
  // background-image: url("https://img01.yzcdn.cn/vant/apple-3.jpg");
}
.bq-tag {
}
.loading-container {
}

// 等待特效
.google-loader {
  display: block;
  padding: 0 10px 0 10px;
}

.google-loader span {
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.google-loader span:not(:first-child) {
  margin-left: 5px;
}

.google-loader span:nth-child(1) {
  background: rgba(30, 223, 65, 1);
  animation: move 0.75s ease-in-out 0s infinite alternate;
}

.google-loader span:nth-child(2) {
  background: rgba(30, 223, 65, 0.7);
  animation: move 0.75s ease-in-out -0.25s infinite alternate;
}

.google-loader span:nth-child(3) {
  background: rgba(30, 223, 65, 0.4);
  animation: move 0.75s ease-in-out -0.5s infinite alternate;
}

.google-loader span:nth-child(4) {
  background: rgba(30, 223, 65, 0.2);
  animation: move 0.75s ease-in-out -0.75s infinite alternate;
}

@keyframes move {
  from {
    transform: translateY(-5px);
  }
  to {
    transform: translateY(5px);
  }
}
.container-item-new{
  position: relative;
  float: left;
  width: 100%;
  margin-top: 6px;
  padding: 4px 0 4px 8px;
  border-radius: 8px;
  box-sizing: border-box;
}

</style>
